import { toggleQuickComments } from 'store/order/quickForms/quickFormsSlice';
import { MobileDialog } from './MobileDialog';
import React, { useMemo } from 'react';
import { useAppSelector, useAppDispatch } from 'store/store';
import { QuickCommentForm } from './QuickCommentForm';

export const QuickCommentContainer: React.FC = () => {
  const { isOpenQuickComments } = useAppSelector((root) => root.order.quickFormsSlice);
  const dispatch = useAppDispatch();

  const body = useMemo(() => {
    return ({ dialogControls }: { dialogControls: React.ReactNode; expanded: boolean }) => (
      <QuickCommentForm dialogControls={dialogControls} />
    );
  }, []);

  return (
    <MobileDialog
      title={'Comments'}
      isOpen={isOpenQuickComments}
      onClose={() => dispatch(toggleQuickComments())}
      Body={body}
    />
  );
};
